<template>
  <div class="activation-config-container">
    <div class="tabs">
      <button class="button-tab with-margin-left" :class="{'selected' : activeTab === 1}" @click="activeTab = 1">Activation details</button>
      <button class="button-tab" :class="{'selected' : activeTab === 2}" @click="activeTab = 2">Survey form</button>
    </div>

    <div class="tab-content-container">
      <div class="form" v-if="activeTab === 1">

        <div class="cta-shortcut-container">

          <p class="cta-shortcut-heading">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M10.4354 3.45H10.3854V3.5V4.67391V4.72391H10.4354H11.168V5.05807C6.99696 5.47668 3.7332 9.00243 3.7332 13.2826C3.7332 17.8439 7.43928 21.55 12.0006 21.55C16.5619 21.55 20.268 17.8439 20.268 13.2826C20.268 9.00243 17.0042 5.47668 12.8332 5.05807V4.72391H13.5658H13.6158V4.67391V3.5V3.45H13.5658H10.4354ZM17.998 4.69588L17.9626 4.66052L17.9273 4.69588L17.1424 5.48078L17.107 5.51613L17.1424 5.55149L18.9483 7.35745L18.9837 7.39281L19.0191 7.35745L19.804 6.57255L19.8393 6.53719L19.804 6.50184L17.998 4.69588ZM8.08373 8.92444H8.08372C7.99593 8.92446 7.91014 8.95067 7.83732 8.9997C7.7645 9.04874 7.70796 9.11837 7.67493 9.19971C7.64189 9.28105 7.63387 9.37039 7.65187 9.45631C7.66985 9.54211 7.71298 9.62061 7.77575 9.6818C7.77584 9.68189 7.77592 9.68197 7.77601 9.68206L11.1901 13.0961C11.1757 13.1571 11.1683 13.2196 11.168 13.2824V13.2826C11.168 13.5034 11.2557 13.7152 11.4119 13.8714C11.568 14.0275 11.7798 14.1152 12.0006 14.1152H12.0006C12.0636 14.1152 12.1264 14.108 12.1878 14.0938L12.8618 14.7678C12.8619 14.7679 12.862 14.7681 12.8622 14.7682C12.9027 14.8104 12.9513 14.8441 13.005 14.8673C13.0589 14.8906 13.1169 14.9029 13.1756 14.9035C13.2344 14.9041 13.2926 14.8929 13.347 14.8708C13.4013 14.8486 13.4507 14.8157 13.4922 14.7742C13.5337 14.7327 13.5665 14.6833 13.5887 14.629C13.6109 14.5746 13.6221 14.5164 13.6215 14.4577C13.6209 14.399 13.6086 14.3409 13.5853 14.2871C13.562 14.2333 13.5284 14.1848 13.4862 14.1442C13.4861 14.144 13.4859 14.1439 13.4858 14.1438L12.8111 13.4691C12.8255 13.4081 12.8329 13.3456 12.8332 13.2829V13.2826C12.8332 13.0618 12.7455 12.85 12.5893 12.6939C12.4332 12.5377 12.2214 12.45 12.0006 12.45H12.0006C11.9375 12.45 11.8748 12.4572 11.8134 12.4714L8.40005 9.05804C8.39997 9.05795 8.39988 9.05786 8.39979 9.05776C8.35872 9.01562 8.30963 8.98211 8.25542 8.95921C8.20109 8.93627 8.14271 8.92444 8.08373 8.92444ZM12.0006 5.89783C16.0837 5.89783 19.3854 9.19947 19.3854 13.2826C19.3854 17.3657 16.0837 20.6674 12.0006 20.6674C7.91746 20.6674 4.61581 17.3657 4.61581 13.2826C4.61581 9.19947 7.91746 5.89783 12.0006 5.89783Z" fill="black" stroke="black" stroke-width="0.1"/>
            </svg>
            Unlock offer
          </p>

          <div class="input-container">
            <p class="label">Days to delay action</p>
            <input type="number" v-model="ctaUnlockAction.delayed_duration" :min="0">
          </div>
        </div>

        <div class="input-container">
          <p class="label">Quick text</p>
          <input type="text" v-model="updatedActivation.quick_text">
          <p class="helper-text">50 characters</p>
        </div>

        <div class="input-container">
          <p class="label">Title</p>
          <input type="text" v-model="updatedActivation.first_header">
          <p class="helper-text">50 characters</p>
        </div>

        <div class="input-container">
          <p class="label">Button title</p>
          <input type="text" v-model="updatedActivation.link_button_title">
        </div>
      </div>

      <div class="form" v-if="activeTab === 2">
        <div class="input-container">
          <p class="label">Survey description</p>
          <CKEditor v-model="updatedActivation.second_header" :config="editorConfig">
          </CKEditor>
          <p class="helper-text">300 characters</p>
        </div>

        <SurveyEditor
          :survey="this.updatedActivation.survey"
          :requirements="{ upload: true }"
          @change="updatedActivation.survey = $event"
        />
      </div>

    </div>

  </div>
</template>

<script>
import PartnerMixin from '@/mixins/PartnerMixin.vue'
import SurveyEditor from '../SurveyEditor/SurveyEditor.vue'
import CKEditor from '@/stories/components/CKEditor/CKEditor.vue';

export default {
  components: { SurveyEditor, CKEditor },
  props: {
    activation: {
      type: Object,
      required: true,
    },
  },
  watch: {
    'updatedActivation.quick_text'(value) {
      this.emitChanges('quick_text', value);
    },
    'updatedActivation.first_header'(value) {
      this.emitChanges('first_header', value);
    },
    'updatedActivation.second_header'(value) {
      this.emitChanges('second_header', value);
    },
    'updatedActivation.link_button_title'(value) {
      this.emitChanges('link_button_title', value);
    },
    'updatedActivation.cta_actions': {
      handler(value) {
        this.emitChanges('cta_actions', value);
      },
      deep: true
    },
    'updatedActivation.survey': {
      handler(value) {
        this.emitChanges('survey', value);
      },
      deep: true,
    },
  },
  data() {
    return {
      updatedActivation: {
        ...this.activation,
        survey: Array.isArray(this.activation.survey) ? [...this.activation.survey] : [],
      },
      activeTab: 1,
      editorConfig: {
      toolbar: [ [ 'Bold', 'Italic', 'Strike', '-', 'RemoveFormat', '-', 'NumberedList', 'BulletedList', '-',
        'Outdent', 'Indent', '-', 'Blockquote', '-', 'Styles', '-', 'Format', '-',  ] ]
      },
    }
  },
  computed: {
    ctaUnlockAction() {
      const unlockAction = this.updatedActivation.cta_actions.find(action => action.type === 'UNLOCK-OFFER' && action.trigger === 'CTA-DONE')
      return unlockAction || { delayed_duration: 0 }
    },
  },
  methods: {
    emitChanges(keyOrChange, value) {
      this.$emit('changeData', typeof value !== undefined
        ? { [keyOrChange]: value }
        : { ...keyOrChange }
      );
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./ActivationStep";

.tab-content-container {
  margin-top: 0px;
}

.form {
  padding-top: 0;
}

.cta-shortcut-container {
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 24px 16px;
  border-radius: 4px;
  border: 1px dashed #CCC;

  .cta-shortcut-heading {
    display: flex;
    align-items: center;
    gap: 4px;

    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    color: #333;
  }
}
</style>

